import { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styles from '../../../../ReviewEmployeeAccess.module.scss';
import {
	getServiceAccountsByUser,
	getServiceAccountApps,
} from '../../../../_api';
import { DataTable } from '../../../../../../../../../components/UI/MDC/DataTable/DataTable';
import Button from '@mui/material/Button';
import Spinner from '../../../../../../../../../components/UI/Spinner/Spinner';
import Modal from '@mui/material/Modal';

const ReviewServiceAccounts = ({ staffMember, index, formik }) => {
	const [isLoading, setIsLoading] = useState(false);
	useEffect(() => {
		setIsLoading(true);
		if (
			staffMember?.fiId &&
			(!staffMember?.serviceAccounts ||
				staffMember?.serviceAccounts.length === 0)
		) {
			getServiceAccountsByUser(staffMember?.fiId).then(response => {
				let formikStaffMember =
					formik.values.staffMembersForReview[index];
				formikStaffMember.serviceAccounts = response.data.payload;
				//update formik state with user applications
				let updatedFormikStaffMembers = [
					...formik.values.staffMembersForReview,
				];
				updatedFormikStaffMembers.splice(index, 1, formikStaffMember);
				formik.setFieldValue('staffMembersForReview', [
					...updatedFormikStaffMembers,
				]);
				setIsLoading(false);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const ServiceAccountsTable = {
		headers: [
			{
				Value: 'UPMC E-Sign-On ID',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Apps',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Network ID',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Description',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Date Validation Due',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Date Last Validated',
				props: { sort: null, onSortChange: null },
			},
		],
		rows: staffMember.serviceAccounts?.map((serviceAccount, index) => {
			console.log('serviceaccountsssss', serviceAccount);
			return {
				Cells: {
					'UPMC E-Sign-On ID': {
						Value:
							serviceAccount.eso + ` (${serviceAccount.esoFiId})`,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Apps: {
						Value: (
							<ServiceAccountApps
								serviceAccount={serviceAccount}
								staffMember={staffMember}
								index={index}
								formik={formik}
							/>
						),
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					'Network ID': {
						Value: serviceAccount.ntid,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Description: {
						Value: (
							<p className={styles.cell_max_width}>
								{serviceAccount.description}
							</p>
						),
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					'Date Validation Due': {
						Value: new Date(
							serviceAccount.dateValidationDue
						).toLocaleDateString(),
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					'Date Last Validated': {
						Value: (
							<>
								<p>
									{new Date(
										serviceAccount.dateLastValidated
									).toLocaleDateString()}{' '}
									{new Date(
										serviceAccount.dateLastValidated
									) <
									new Date(
										serviceAccount.dateValidationDue
									) ? (
										<span className={styles.Text_error}>
											(expired)
										</span>
									) : null}
								</p>
							</>
						),
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Key: serviceAccount.esoFiId.toString(),
				},
			};
		}),
	};

	return (
		<>
			<div className={styles.margin_top_small}>
				<Accordion className={styles.accordion}>
					<AccordionSummary
						className={styles.accordion_summary_secondary}
						expandIcon={
							<ArrowDownwardIcon
								className={styles.accordion_summary_secondary}
							/>
						}
						aria-controls={'StaffMember-content-' + index}
						id={'StaffMember-header-' + index}
					>
						<Typography>ServiceAccounts</Typography>
					</AccordionSummary>
					<AccordionDetails className={styles.accordion_details}>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								{staffMember?.serviceAccounts &&
								staffMember.serviceAccounts.length > 0 ? (
									<DataTable
										rows={ServiceAccountsTable.rows}
										headers={ServiceAccountsTable.headers}
									/>
								) : (
									<p>
										no service accounts found for this user
									</p>
								)}
							</>
						)}
					</AccordionDetails>
				</Accordion>
			</div>
		</>
	);
};

export default ReviewServiceAccounts;

/** internal */
const ServiceAccountApps = ({ serviceAccount }) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [apps, setApps] = useState([]);

	const openModal = () => {
		//if apps is null or an empty array, retrieve service account apps and set state
		if (apps.length === 0) {
			setIsLoading(true);
			getServiceAccountApps(serviceAccount.esoFiId)
				.then(response => {
					if (response?.data?.payload?.length > 0) {
						setApps(response.data.payload);
					}
				})
				.then(() => setIsLoading(false));
		}

		setModalOpen(true);
	};

	const headers = [
		{
			Value: 'Name',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'User Name',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Role',
			props: { sort: null, onSortChange: null },
		},
	];
	const rows = apps.map((app, index) => {
		return {
			Cells: {
				Name: {
					Value: app.name,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'User Name': {
					Value: app.username,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Role: {
					Value: <p className={styles.cell_max_width}>{app.role}</p>,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Key: app.id.toString(),
			},
		};
	});

	return (
		<>
			<Button onClick={openModal}>Apps</Button>
			<Modal
				open={modalOpen}
				onClose={() => {
					setModalOpen(false);
				}}
			>
				<div className={styles.Modal}>
					{isLoading ? (
						<Spinner />
					) : apps.length > 0 ? (
						<>
							<h3>
								Applications for service account{' '}
								{serviceAccount.eso}
							</h3>
							<DataTable rows={rows} headers={headers} />
						</>
					) : (
						<p>
							no apps found for service account{' '}
							{serviceAccount.eso}
						</p>
					)}
				</div>
			</Modal>
		</>
	);
};
